<template>
  <div class="animated fadeIn">
    <div class="card card-yellow">
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-2">
            <b-form-select :options="status" v-model="childStatus" value-field="value" text-field="text"></b-form-select>
          </div>
          <div class="col-2">
              <lb-vue-select v-model= "logopedId"
                              :list= "users.root"
                              :totalCount= "users.totalCount"
                              display-field= "username"
                              value-field= "userId"
                              :search-placeholder= "$t('SEARCH')"
                              :items-placeholder= "$t('USERS')">
                </lb-vue-select>
          </div>
          <div class="col-8">
            <button type="button" class="btn btn-primary button-add pull-right" @click="showModal()">{{$t('NEW')}}</button>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 table-responsive">
              <gridprint :table-data="response.root" :filters="getParams" method="children_kindergarten/ChildKindergarten.selectRow"></gridprint>
              <table class="table table-sm table-bordered table-striped table-hover table-logoped">
                <thead>
                  <tr>
                    <th>{{$t('NUM')}}</th>
                    <th>
                      <sortingcolumn v-model="pagination" field="name" v-on:reload="getData">{{$t('NAME')}}</sortingcolumn>
                    </th>
                    <th>
                      <sortingcolumn v-model="pagination" field="surname" v-on:reload="getData">{{$t('SURNAME')}}</sortingcolumn>
                    </th>
                    <th>
                      {{$t('EDUCATIONALGROUP')}}
                    </th>
                    <th>
                      {{$t('OBJECTNAME')}}
                    </th>
                    <th>
                      <sortingcolumn v-model="pagination" field="birthDate" v-on:reload="getData">{{$t('BIRTHDATE')}}</sortingcolumn>
                    </th>
                    <th>{{$t('ACTION')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="item in response.root">
                    <tr :key="item.childKindergartenId" aria-rowindex="1" class=" table-ellipsis">
                      <td>{{item.num}}</td>
                      <td>
                        <router-link :to="'/admin/childkindergarten/child/childdetails/'+ item.childKindergartenId">
                          {{item.name}}
                        </router-link>
                      </td>
                      <td>{{item.surname}}</td>
                      <td>{{item.educationalGroupName}}</td>
                      <td>{{item.objectName}}</td>
                      <td>{{moment(item.birthDate).format('DD.MM.YYYY')}}</td>
                      <td>
                        <div class="btn-toolbar">
                        <button type="button" class="btn btn-primary mr-2 button-save"  @click="showChildDetails(item.childKindergartenId)">{{$t('INFO')}}</button>
                        <button type="button" class="btn mr-2 button-edit"  @click="showModal(item)">{{$t('EDIT')}}</button>
                        <button type="button" class="btn button-dlt" @click="deleteRow(item.childKindergartenId)">{{$t('DELETE')}}</button>
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <nav>
                <pagination
                  v-bind:totalCount="response.totalCount"
                  v-model="pagination"
                  v-on:reload="getData"></pagination>
              </nav>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="formmodal" :title="$t('CHILDFORM')" ok-title="submit" hide-footer size="xl" no-close-on-backdrop @close="hideModal()">
      <template #modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <h5 id="__BVID__119___BV_modal_title_" class="modal-title">{{$t('CHILDFORM')}}</h5>
        <div class="text-right">
          <b-btn class="mr-2 btn button-cancel" @click="close()">{{$t('CANCEL')}}</b-btn>
          <b-btn class="btn button-save" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
        </div>
      </template>
      <div class="d-block">
        <childform v-bind:formData="formData" v-bind:formError="formError"></childform>
      </div>
      <div class="text-right">
        <b-btn class="mr-2 btn button-cancel" @click="hideModal()">{{$t('CANCEL')}}</b-btn>
        <b-btn class="btn button-save" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import
{
    mapGetters,
}
    from 'vuex';
import moment from 'moment';
import Api from '@/api/child_kindergarten/ChildKindergarten';
import UsersApi from '@/api/admin/Users';
import ChildForm from './Form.vue';

export default
{
    name: 'Child',
    components:
  {
      childform: ChildForm,
  },
    data()
    {
        const me = this;
        return {
            response:
      {},
            formError:
      {},
            childStatus: 'active',
            logopedId: 0,
            users: {},
            formData:
      {
          name: '',
          surname: '',
          birthDate: null,
          parentId: null,
          educationalGroupId: null,
          objectNameId: null,
          note: '',
          anamnestic: '',
          communication: '',
          instrument: '',
          opinion: '',
          status: 'active',
          diagnoseId: null,
          userId: null,
      },
            pagination:
      {
          query: '',
          currentPage: 1,
          limit: 25,
          searchTimeout: false,
      },
            status:
      [
          {
              value: 'active',
              text: me.$i18n.t('ACTIVE'),
          },
          {
              value: 'inactive',
              text: me.$i18n.t('INACTIVE'),
          },
      ],
        };
    },
    created()
    {
        const me = this;
        me.getData();
        me.getUsers();
    },
    methods:
  {
      showChildDetails(id)
      {
          const me = this;
          me.$router.push(
              {
                  path: `/admin/childkindergarten/child/childdetails/${id}`,
              },
          );
      },
      async getData()
      {
          const me = this;
          try
          {
              const data = await Api.selectRow(me.getParams);
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  me.loading = false;
                  return;
              }

              me.response = data;
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      async deleteRow(id)
      {
          const me = this;
          try
          {
              me.$store.commit('setModalAlert',
                  {
                      text: me.$i18n.t('AREYOUSHURE'),
                      async btnAction()
                      {
                          const data = await Api.deleteRow(
                              {
                                  id,
                              },
                          );
                          me.$notify.notice(data);
                          await me.getData();
                      },
                  });
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      showModal(item)
      {
          const me = this;
          if (typeof item !== 'undefined')
          {
              me.formData = item;
          }
          this.$refs.formmodal.show();
      },
      async submitData(item)
      {
          const me = this;
          try
          {
              if (typeof item.childKindergartenId !== 'undefined')
              {
                  item.id = item.childKindergartenId;
                  delete (item.childKindergartenId);
              }

              item.birthDate = moment(item.birthDate).format('YYYY-MM-DD');
              const data = await Api.submitData(item);
              if (data.error)
              {
                  me.$notify.notice(data);
                  me.formError = data;
              }
              else
              {
                  me.$notify.notice(data);
                  me.hideModal();
                  await me.getData();
              }
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      hideModal()
      {
          const me = this;
          this.$refs.formmodal.hide();

          me.formData = {
              name: '',
              surname: '',
              parentId: null,
              educationalGroupId: null,
              objectNameId: null,
              note: '',
              anamnestic: '',
              communication: '',
              instrument: '',
              opinion: '',
              userId: null,
          };
      },
      async getUsers()
      {
          const me = this;
          try
          {
              const data = await UsersApi.selectRow();
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  me.loading = false;
                  return;
              }

              for (let i = 0; i < data.root.length; i += 1)
              {
                  data.root[i].password = '';
                  data.root[i].trhidden = false;
              }

              data.root.push({
                  userId: 0,
                  username: 'All',
              });

              me.users = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
      },
  },
    watch:
  {
      'pagination.limit'()
      {
          const me = this;
          me.getData();
      },
      'pagination.currentPage'()
      {
          const me = this;
          me.getData();
      },
      'pagination.query'()
      {
          const me = this;

          if (me.pagination.searchTimeout !== false)
          {
              clearTimeout(me.pagination.searchTimeout);
          }

          me.pagination.searchTimeout = setTimeout(() =>
          {
              me.getData();
              me.pagination.searchTimeout = false;
          }, 300);
      },
      childStatus()
      {
          const me = this;
          me.getData();
      },
      logopedId()
      {
          const me = this;
          me.getData();
      },
  },
    computed:
  {
      ...mapGetters([
          'globals',
      ]),
      getParams()
      {
          const me = this;
          const data = {
              ...me.pagination,
          };
          data.status = me.childStatus;
          data.userId = me.logopedId;
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
  },
};
</script>
